import script from "./MainMenuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuComponent.vue?vue&type=style&index=0&id=77b5682e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b5682e"]])

export default __exports__